<script lang="ts" setup>
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const page = usePage();

const props = withDefaults(
    defineProps<{
        rows: number;
        text: string;
        hide?: Array<
            "facebook" | "twitter" | "whatsapp" | "messenger" | "reddit"
        >;
    }>(),
    {
        rows: 1,
    },
);

const url = computed(() => {
    return encodeURIComponent(page.props.ziggy.location);
});

const textEncoded = computed(() => {
    return encodeURIComponent(props.text);
});

const classes = computed<object>(() => {
    return {
        "grid-rows-1": props.rows === 1,
        "grid-rows-2": props.rows === 2,
        "grid-rows-3": props.rows === 3,
    };
});

const canShare = computed(() => {
    return typeof navigator !== "undefined" && navigator.share;
});

function share() {
    navigator.share({
        title: props.text,
        text: props.text,
        url: page.props.ziggy.location,
    });
}
</script>

<template>
    <div
        class="flex h-fit flex-col items-center gap-2 rounded-md bg-black/50 p-2 shadow-sm"
    >
        <span class="font-condensed text-xs font-bold uppercase tracking-wider"
            >Share</span
        >
        <div :class="classes" class="grid grid-flow-col gap-2 text-lg">
            <a
                v-if="!hide?.includes('twitter')"
                :href="`https://twitter.com/intent/tweet?text=${textEncoded}&url=${url}&hashtags=DokkanBattle&via=dokkanfyi`"
                target="_blank"
            >
                <i-fa6-brands-x-twitter
                    class="drop-shadow-sm hover:text-yellow-300"
                />
            </a>

            <a
                v-if="!hide?.includes('facebook')"
                :href="`https://www.facebook.com/dialog/share?href=${url}&app_id=1685779322250209&hashtag=#DokkanBattle`"
                target="_blank"
            >
                <i-fa6-brands-facebook
                    class="drop-shadow-sm hover:text-yellow-300"
                />
            </a>

            <a
                v-if="!hide?.includes('whatsapp')"
                :href="`https://api.whatsapp.com/send?text=${textEncoded} ${url}`"
                target="_blank"
            >
                <i-fa6-brands-whatsapp
                    class="drop-shadow-sm hover:text-yellow-300"
                />
            </a>

            <a
                v-if="!hide?.includes('reddit')"
                :href="`https://new.reddit.com/submit?url=${url}&title=${textEncoded}`"
                target="_blank"
            >
                <i-fa6-brands-reddit
                    class="drop-shadow-sm hover:text-yellow-300"
                />
            </a>

            <i-ic-baseline-share
                v-if="canShare"
                class="drop-shadow-sm hover:cursor-pointer hover:text-yellow-300"
                @click="share"
            />
        </div>
    </div>
</template>

<style scoped></style>
